var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoStub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 59,
    r: 8,
    fill: "#141414"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 75C20.1797 75 26 69.1797 26 62C26 54.8203 20.1797 49 13 49C5.8203 49 0 54.8203 0 62C0 69.1797 5.8203 75 13 75ZM14.4444 54.0556C14.4444 53.2578 13.7977 52.6111 13 52.6111C12.2023 52.6111 11.5556 53.2578 11.5556 54.0556V61.6389C11.5556 62.6361 12.3639 63.4444 13.3611 63.4444H18.0556C18.8533 63.4444 19.5 62.7977 19.5 62C19.5 61.2023 18.8533 60.5556 18.0556 60.5556H14.4444V54.0556Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.531 10.959C15.879 10.959 9.67578 17.0921 9.67578 24.6576V45.3249C10.7508 45.1117 11.8624 45 13 45C22.3888 45 30 52.6112 30 62C30 63.2898 29.8564 64.546 29.5842 65.7535H60.4781C68.1301 65.7535 74.3333 59.6204 74.3333 52.0549V24.6576C74.3333 17.0921 68.1301 10.959 60.4781 10.959H23.531Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4925 33.4018L37.9525 26.0833C34.0862 24.2625 29.7852 27.379 29.7852 32.0014V44.6657C29.7852 49.2882 34.0862 52.4047 37.9525 50.5838L53.4925 43.2653C57.4383 41.407 57.4383 35.2601 53.4925 33.4018Z",
    fill: "#141414"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoStub);
export default __webpack_public_path__ + "static/media/video_stub.7b7ea900c10735f20e1dad6e70e4e91e.svg";
export { ForwardRef as ReactComponent };